import { Button } from "@/components/ui/button";
import { ExternalLink, BookOpen } from "lucide-react";

export default function StaffManual() {
  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 md:py-10 space-y-6" data-testid="staff-manual-page">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="font-heading text-3xl md:text-4xl font-bold uppercase tracking-tight flex items-center gap-3"><BookOpen className="w-8 h-8 text-court-orange" />Back-Office Staff Manual</h1>
          <p className="text-muted-foreground mt-1">Role-specific guide for staff login, RBAC, approval queue, checker pools, and finance governance workflows.</p>
        </div>
        <Button asChild variant="outline" className="rounded-md" data-testid="open-staff-manual-public-btn">
          <a href="/backoffice-staff-manual.html" target="_blank" rel="noreferrer"><ExternalLink className="w-4 h-4 mr-2" />Open Public Manual</a>
        </Button>
      </div>
      <div className="border border-zinc-200 bg-white overflow-hidden" style={{ height: "75vh" }}>
        <iframe src="/backoffice-staff-manual.html" title="Back-Office Staff Manual" className="w-full h-full" data-testid="staff-manual-iframe" />
      </div>
    </div>
  );
}